import React, { useState } from "react";

import { useStoreSearchContext } from "../../storeSearch.context";
import { StoreSearchFiltersComponent } from "./storeSearchFilters.component";

type StoreSearchFiltersProps = {};

const StoreSearchFilters = ({}: StoreSearchFiltersProps) => {
    const { storeFeatures, toggleSearchParam } = useStoreSearchContext();

    const [activeSearchFilters, setActiveSearchFilters] = useState<
        Array<string>
    >(new URLSearchParams(location.search).getAll("features"));

    const handleOnToggleSearchFilter = (filter: string) => {
        const searchParams = toggleSearchParam("features", filter);

        setActiveSearchFilters(searchParams.getAll("features"));
    };

    return (
        <StoreSearchFiltersComponent
            activeSearchFilters={activeSearchFilters}
            storeFeatures={storeFeatures}
            onToggleStoreSearchFilter={handleOnToggleSearchFilter}
        />
    );
};

export { StoreSearchFilters };
